import { EOIRCaseInfoActions } from './actions'
import { EOIRCaseInfoGetters } from './getters'
import { EOIRCaseInfoMutations } from './mutations'
import { EOIRCaseInfoState } from './state'

export const EOIR_CASE_INFO_NAMESPACE = 'EOIRCaseInfo'

export const EOIRCaseInfo = {
  namespaced: true,
  state: EOIRCaseInfoState,
  actions: EOIRCaseInfoActions,
  mutations: EOIRCaseInfoMutations,
  getters: EOIRCaseInfoGetters,
}
